ui.carousel('#carouselFullWidth', {
	continuous: false
});
ui.carousel('#fullWidthPreviews', {
	showPreviews: true,
	carouselHeight: '300px' /* recommended */,
	firstSlide: 2
});
ui.carousel('#galleryDefault', {
	fullWidth: false
});
ui.carousel('#galleryScrollMultipleSlides', {
	fullWidth: false,
	slidesPerScroll: 5
});
ui.carousel('#galleryWithPreviews', {
	fullWidth: false,
	showPreviews: true,
	firstSlide: 2
});
ui.carousel('#dots', {
	pagination: 'dots',
	showPrevNextBtns: false
});
ui.carousel('#slideshow', {
	autoscroll: 2000, /* must be greater than 0 */
	continuous: true, /* recommended */
	showPrevNextBtns: false, /* optional */
	showPausePlayBtns: true, /* optional */
	pagination: 'numbers' /* optional */
});
// varied heights
ui.carousel('#variedHeight', {
	continuous: true,
	carouselHeight: 'varied'
});
// load dynamic content with callbacks
const slide1 = '<div class="slide1Content"><img src="https://www.placehold.it/399x244/{{hex}}/ffffff/?text={{slideText}}" alt="Slide 1"><h3>Slide {{slideNum}} was updated!</h3><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur, vero, architecto exercitationem necessitatibus nesciunt rem id blanditiis reprehenderit maxime porro vel obcaecati qui illo voluptatem dicta magni atque. Maxime, praesentium.</p></div>';

const dynamicCarousel = document.getElementById('dynamic-carousel');
dynamicCarousel.classList.add('carouselArrowsOutside');
dynamicCarousel.insertAdjacentHTML('beforeend', '<div id="message" class="topSpacing"></div><ol class="carouselInner"><li class="carouselSlide loading"/><li class="carouselSlide loading"/><li class="carouselSlide loading"/><li class="carouselSlide loading"/><li class="carouselSlide loading"/><li class="carouselSlide loading"/></ol>');
ui.carousel(dynamicCarousel, {
	pagination: 'numbers',
	onSlideChange: args => {
		const message = document.getElementById('message');
		message.innerHTML = `<p class="textlrg">The new slide's index is: <strong>${args.slideIndex}</strong>; The last slide's index is: <strong>${args.previousSlideIndex}</strong>.</p>`;
	},
	onSlideLoad: args => {
		/* Do NOT use setTimeout, this is simply here to show loading icon & simulate http request */
		setTimeout(() => {
			const slide = args.slideElement;
			let formatSlide = slide1.replace('{{slideNum}}', args.slideIndex + 1);
			formatSlide = formatSlide.replace('{{slideText}}', `Slide ${args.slideIndex + 1}`);
			const slideColor = Math.random().toString(16).slice(2, 8);
			formatSlide = formatSlide.replace('{{hex}}', slideColor);
			slide.insertAdjacentHTML('beforeend', formatSlide);
			slide.classList.remove('loading');
		}, 1000);
	}
});
// infinite carousel using strings to generate new slides
let i = 2;
ui.carousel('#infinite1', {
	infinite: true,
	// args object -> { isFirstSlide: newSlide.index === 0, isLastSlide: newSlide.index === this.lastSlide.index, previousSlideElement: prevSlide.element, previousSlideIndex: prevSlide.index, slideElement: newSlide.element, slideIndex: newSlide.index };
	onAfterSlideChange: args => {
		let newSlide;
		const slideIndex = args.slideIndex;
		if (slideIndex === 2) {
			i += 1;
			newSlide = `<li class="carouselSlide"><img alt="Slide${i + 1}" src="//placehold.it/500x300&text=Slide+${i + 1}"></li>`;
		} else if (slideIndex === 0) {
			i -= 1;
			newSlide = `<li class="carouselSlide"><img alt="Slide${i - 1}" src="//placehold.it/500x300&text=Slide+${i - 1}"></li>`;
		}
		return newSlide;
	}
});
// infinite carousel using HTML elements to generate new slides
const createNewSlide = (index, hex = '#cccccc') => {
	const newElement = document.createElement('li');
	newElement.classList.add('carouselSlide');
	newElement.insertAdjacentHTML('beforeend', `<img alt="Slide${index}" src="//placehold.it/500x300/${hex}/ffffff/&text=Slide+${index}">`);
	return newElement;
};
let j = 2;
ui.carousel('#infinite2', {
	carouselHeight: '300px',
	infinite: true,
	onAfterSlideChange: args => {
		let newSlide;
		const slideColor = Math.random().toString(16).slice(2, 8);
		const slideIndex = args.slideIndex;
		if (slideIndex === 2) {
			j += 1;
			newSlide = createNewSlide(j + 1, slideColor);
		} else if (slideIndex === 0) {
			j -= 1;
			newSlide = createNewSlide(j - 1, slideColor);
		}
		return newSlide;
	}
});
// infinite carousel injecting html
// mimicking Angular behavior
let k = 2;
const injectCarousel = ui.carousel('#infinite3', {
	infinite: true,
	onAfterSlideChange: args => {
		let newSlide;
		const inner = injectCarousel.element.querySelector('.carouselInner');
		const slideIndex = args.slideIndex;
		const isNext = args.previousSlideIndex < slideIndex;
		const newSlides = [];
		const slideColor = Math.random().toString(16).slice(2, 8);
		const slides = injectCarousel.element.querySelectorAll('.carouselSlide');
		if (isNext) {
			k += 1;
			newSlide = createNewSlide(k + 1, slideColor);
			newSlides.push(slides[1], slides[2], newSlide);
		} else {
			k -= 1;
			newSlide = createNewSlide(k - 1, slideColor);
			newSlides.push(newSlide, slides[0], slides[1]);
		}
		slides.forEach(slide => slide.remove());
		newSlides.forEach(slide => inner.insertAdjacentElement('beforeend', slide));
		return '';
	}
});
// finite carousel i.e. an infinite carousel with a specified slide range
let page = 2;
const firstSlide = 1;
const lastSlide = 5;
const finiteCarousel = ui.carousel('#finite', {
	infinite: true,
	onAfterSlideChange: args => {
		let newSlide;
		const prevPage = page;
		const slideIndex = args.slideIndex;
		const isNext = args.previousSlideIndex < slideIndex;
		page = isNext ? page + 1 : page - 1;
		if (page === firstSlide) {
			finiteCarousel.setButtonState('previous', false);
		} else if (page === lastSlide) {
			finiteCarousel.setButtonState('next', false);
		}
		if (prevPage === lastSlide) {
			finiteCarousel.setButtonState('next', true);
		} else if (prevPage === firstSlide) {
			finiteCarousel.setButtonState('previous', true);
		}
		if (slideIndex === 2 && page <= lastSlide) {
			newSlide = `<li class="carouselSlide"><img alt="Slide${page + 1}" src="//placehold.it/600x300&text=Slide+${page + 1}"></li>`;
		} else if (slideIndex === 0 && page >= firstSlide) {
			newSlide = `<li class="carouselSlide"><img alt="Slide${page - 1}" src="//placehold.it/600x300&text=Slide+${page - 1}"></li>`;
		}
		return newSlide;
	}
});
// small carousel
ui.carousel('#carouselSmall');



// WEBPACK FOOTER //
// ./src/components/carousel/carousel.demo.js